module.exports = __webpack_public_path__ + "static/img/6.a541136.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/6.png
// module id = Sqq6
// module chunks = 0